import { useTranslation } from '@hopin-team/provider-translation';
import React from 'react';

import ErrorFrame1 from '../../images/error-frame1.png';
import ErrorFrame2 from '../../images/error-frame2.png';
import ErrorFrame3 from '../../images/error-frame3.png';
import ErrorFrame4 from '../../images/error-frame4.png';
import { Button } from '..';

export const ErrorScreen = ({ showButton }: { showButton: boolean }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center mt-6">
      <div className="relative w-[160px] h-[160px] rounded-full bg-[#9cd7f2] overflow-hidden mb-6">
        <img
          className="absolute w-[114px] h-[88px] left-[20px] top-[33px] z-20"
          src={ErrorFrame1}
          alt={t('analytics.error')}
        />
        <img
          className="absolute w-[165px] h-[117px] left-[-2px] top-[21px]"
          src={ErrorFrame2}
          alt={t('analytics.error')}
        />
        <img
          className="absolute w-[150px] h-[74px] left-[-2px] bottom-[10px]"
          src={ErrorFrame3}
          alt={t('analytics.error')}
        />
        <img
          className="absolute w-[134px] h-[89px] left-[11px] bottom-[37px] z-10"
          src={ErrorFrame4}
          alt={t('analytics.error')}
        />
      </div>
      <div className="font-inter font-medium text-center text-sm leading-5 w-72 text-gray-750 mb-6">
        {t('analytics.error-screen-message')}
      </div>
      {showButton && (
        <div className="">
          <Button
            onClick={() => {
              window.location.reload();
            }}
            pattern="outline"
            kind="secondary"
            size="medium"
            className="border-neutral-b4 !rounded-lg outline-none focus-visible:border-blue-500 focus-visible:outline focus-visible:ring-1 focus-visible:outline-1 focus-visible:outline-blue-500 focus-visible:outline-offset-0"
          >
            <span className={'font-medium'}>{t('analytics.refresh')}</span>
          </Button>
        </div>
      )}
    </div>
  );
};
